import Flag from './icon/Flag'

export {
    Flag
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-flag-icon/components/index.js
// module id = 639
// module chunks = 0